import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router';
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import tools from "@/composables/tools";


import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';


import { currentUserStore } from '@/stores/currentUser'
import { useMensajesUnreadStore } from '@/stores/mensajesUnread'
import { User } from '@/interfaces/User';
import { syncDisciplinasActivas, syncProfesores, syncProfesoresIfNeeded } from '@/services/indexedDB';

const pinia = createPinia()


const app = createApp(App)
  .use(IonicVue)
  .use(pinia)
  .use(VueAxios,axios)
  .use(router);
 
  moment.locale('es');
 
  app.config.globalProperties.$filters = {
    timeAgo(date:string) {
      return moment(date).fromNow()
    },
    human(date:string) {
      let val = moment(date).format('dddd D')
      val += ' de '
      val += moment(date).format('MMMM')
      return val
    },
  }
  

router.isReady().then(() => {
  app.mount('#app');
});

router.beforeEach((to) => {
  if(to.meta.requiredAuth && localStorage.getItem('user')==undefined)
  {
      currentUserStore().$state.redirectAfterLogin = to.fullPath
      router.push({path: "/login"});
  }
  return true
})


axios.defaults.baseURL = process.env.VUE_APP_SERVICE_URL
axios.defaults.headers.common["Accept"] = "application/json"
if(localStorage.getItem("token"))
  axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("token");

// Interceptor: 401 → login; otros errores con mensaje seguro (500 puede no traer JSON con .message)
axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status
    const data = error.response?.data
    const msg =
      data && typeof data === 'object' && data !== null && 'message' in data && data.message != null
        ? String((data as { message?: unknown }).message)
        : typeof data === 'string'
          ? data
          : error.message ?? 'Error del servidor'

    if (status === 401) {
      console.log(error.response)
      tools().toast(msg, 'danger')
      useMensajesUnreadStore(pinia).resetAndStop()
      router.push({ path: "/login" })
    } else {
      tools().toast(msg, 'danger', 10000)
    }
    return Promise.reject(error)
  }
)

//** guardamo como state los datos del usuario logeado */
const userJson = localStorage.getItem('user');
const currentUserObj:User = userJson !== null ? JSON.parse(userJson):{ id: 0 }
const currentUser = currentUserStore()
currentUser.update(currentUserObj)

//si en el localStorage hay un token, solicitamos los datos al servidor y lo logeamos
if(localStorage.getItem('token'))
{
  syncDisciplinasActivas();
  syncProfesores(); //en cada arranque (incluido F5) sincronizamos profesores

  axios.get('/user').then(response => {
    currentUser.update(response.data)
    localStorage.setItem('user',JSON.stringify(response.data))
  }).catch(() => { /* 401 lo gestiona el interceptor */ })
}

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState !== 'visible') return;
  if (!localStorage.getItem('token')) return;
  syncProfesoresIfNeeded();
});

